<template>
	<v-container>
		<v-card flat>
			<v-card-title class="text-h4">{{ title }}</v-card-title>
			<v-card-text>
				<v-expansion-panels v-model="panel" multiple flat>
					<v-expansion-panel v-for="(item,i) in items" :key="i">
						<v-expansion-panel-header>
							<!-- <v-icon large :color="item.color">{{ item.icon }}</v-icon>
							<div class="text-h6">{{ item.name }}</div> -->
							<v-toolbar dense flat>
								<v-app-bar-nav-icon>
									<v-icon large :color="item.color">{{ item.icon }}</v-icon>
								</v-app-bar-nav-icon>
								<v-toolbar-title class="text-h6">{{ item.name }}</v-toolbar-title>
							</v-toolbar>
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-row>
								<v-col cols="12" md="4" v-for="(dict, r) in item.dicts" :key="r">
									<v-hover v-slot:default="{ hover }">
										<v-card 
											:elevation="hover ? 3 : 1"
											:class="{ 'on-hover': hover }"
											class="mx-auto"
											outlined
											:to="{ name: dict.to }"
										>
											<v-list-item three-line>
												<v-list-item-avatar>
													<v-icon :color="dict.color">{{ dict.icon }}</v-icon>
												</v-list-item-avatar>
												<v-list-item-content>
													<v-list-item-title v-html="dict.name" class="font-weight-bold"></v-list-item-title>
													<v-list-item-subtitle v-html="dict.description"></v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>
										</v-card>
															
									</v-hover>
								</v-col>
							</v-row>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</v-card-text>
		</v-card>
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
	name: 'Dictionaries',
	data: () => ({
		title: 'Довідники',
		subtitle: '',
		icon: 'mdi-bookshelf',
		loading: false,
		panel: [0,1,2],
		items: [
			{ code: 'Vehicle', name: 'Транспортні засоби', description: '', icon: 'mdi-car', color: 'green'
				,dicts: [
					{ code: 'VehicleBrandModel', name: 'Марки та моделі', description: 'Систематизований перелік виробників (марок) та модельних рядів транспортних засобів', to: 'VehicleBrandModel', icon: 'mdi-car-side', color: 'green darken-1' },
				]
			},
			{ code: 'Drug', name: 'Лікарські засоби', description: '', icon: 'mdi-pill', color: 'green'
				,dicts: [
					{ code: 'DrugATC', name: 'АТС Класифікація', description: 'Міжнародний стандарт методології для проведення статистичних досліджень у сфері споживання лікарських засобів', to: 'DrugATC', icon: 'mdi-molecule', color: 'green darken-1' },
					{ code: 'DrugNFC', name: 'NFС Класифікація', description: 'Міжнародний стандарт методології для проведення статистичних досліджень у сфері споживання лікарських засобів', to: 'DrugNFC', icon: 'mdi-lotion', color: 'green darken-1' },
					{ code: 'DrugINN', name: 'МНН', description: 'Міжнародна непатентована назва лікарських засобів', to: 'DrugINN', icon: 'mdi-pill-multiple', color: 'green darken-1' },
					{ code: 'DrugDRLZ', name: 'ДРЛЗ', description: 'Державний реєстр лікарських засобів України', to: 'DrugDRLZ', icon: 'mdi-book-open-variant', color: 'green darken-1' },
					{ code: 'Drug', name: 'Медикаменти', description: 'Реєстр медикаментів та лікарських форм', to: 'Drug', icon: 'mdi-pill', color: 'green darken-1' },
				]
			},
			{ code: 'Medicine', name: 'Медицина', description: '', icon: 'mdi-hospital', color: 'red'
				,dicts: [
					{ code: 'NK025V2021', name: 'МКХ10', description: 'Класифікатор хвороб та споріднених проблем охорони здоров’я', to: 'NK025V2021', icon: 'mdi-heart-pulse', color: 'red darken-1' },
					{ code: 'NK026V2021', name: 'АКМІ', description: 'Класифікатор медичних інтервенцій', to: 'NK026V2021', icon: 'mdi-needle', color: 'red darken-1' },
				]
			},
			{ code: 'Other', name: 'Інші', description: '', icon: 'mdi-library-shelves', color: 'blue'
				,dicts: [
					{ code: 'Koatuu', name: 'КОАТУУ', description: "Класифікатор об'єктів адміністративно-територіального устрою України", to: 'Koatuu', icon: 'mdi-city', color: 'blue darken-1' },
				]
			},
		],

		select: [],

		calculate: {
			services: [],
			requestCount: null,
			userCount: null,
			price: null,
		},

		files: []
	}),
	
	computed: {
		...mapGetters([ 'holder', 'authorized', 'profile', 'services' ]),
	},
	watch: {
		
	},
	created() {
		//console.log(this.$options.name, 'created')
		//this.getFiles()
	},
	methods: {
		/* getFiles() {
			//if(this.organizations.length == 0) {
				var that = this
				this.loading = true;
				axios.get('/report/files').then(response => {
					//console.log(that.$options.name, 'getFiles','response.data', response.data)
					
					that.files = response.data
				}, error => {
					console.log('error', error)
				}).finally(() => {
					this.loading = false
				});
			//}
		}, */
	},
}
</script>